import { render, staticRenderFns } from "./LikeCard.vue?vue&type=template&id=f28f044c&"
import script from "./LikeCard.vue?vue&type=script&lang=js&"
export * from "./LikeCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports